import { Box, Stack } from "@mui/material";
import React, { useEffect, useMemo, useState, ReactNode } from "react";

import parlors from "../../../constants/parlors_detail.json";
import {
  deterministicShuffle,
  applySigunguFallback,
  haversineKm,
  formatDistance,
} from "./shuffle";

// 시군구 단위 결과가 이 수 미만이면 시도 fallback.
// 3 = 서울 시군구 다수(종로/강남/서초 등 4개 시군구)가 시군구 단위로 표시되도록.
// 변경 후 1-2주 색인 추세 보고 조정.
const MIN_LIST_SIZE = 3;

export function BTypeParlorList({
  title,
  binsoAveragePrice,
  sido,
  sigungu,
  currentParlorId,
  currentLat,
  currentLng,
  CardViewType,
}: {
  sido?: string;
  sigungu?: string;
  currentParlorId?: string | number;
  currentLat?: number;
  currentLng?: number;
  title: string;
  binsoAveragePrice?: boolean;
  CardViewType: (res: any) => ReactNode;
}) {
  const parlorCardItems = useMemo(() => {
    const filtered = applySigunguFallback(parlors, sido, sigungu, MIN_LIST_SIZE);

    // 우선순위 1: 좌표 있으면 거리 계산 + 가까운 순 정렬 + distanceKm/distanceLabel 주입
    if (currentLat !== undefined && currentLng !== undefined) {
      return filtered
        .map((p) => {
          const lat = Number((p as any).latitude);
          const lng = Number((p as any).longitude);
          if (isNaN(lat) || isNaN(lng)) return { ...p, distanceKm: null, distanceLabel: "" };
          const km = haversineKm(currentLat, currentLng, lat, lng);
          return { ...p, distanceKm: km, distanceLabel: formatDistance(km) };
        })
        .sort((a, b) => {
          if (a.distanceKm == null) return 1;
          if (b.distanceKm == null) return -1;
          return a.distanceKm - b.distanceKm;
        });
    }

    // 우선순위 2: 셔플 fallback
    const seed = currentParlorId !== undefined ? Number(currentParlorId) : NaN;
    return !isNaN(seed) ? deterministicShuffle(filtered, seed) : filtered;
  }, [sido, sigungu, currentParlorId, currentLat, currentLng]);

  const [averagePrice, setaveragePrice] = useState(0);

  useEffect(() => {
    let price = 0;
    let binsoFullLength = 0;
    parlorCardItems.map((res) => {
      for (let i = 0; i < res.binsos.length - 1; i++) {
        price = price + Number(res.binsos[i].charge);
        binsoFullLength = binsoFullLength + 1;
      }
    });
    setaveragePrice(price / binsoFullLength);
  }, []);

  return (
    <Stack
      sx={{
        padding: "16px",
      }}
    >
      <h2 className="subtitle_18_sb" style={{ textAlign: "center", marginBottom: "4px" }}>
        {title}
      </h2>
      {/* {binsoAveragePrice && (
        <Box component="p" className="caption_12_r" mb="4px" textAlign="center">
          전체 빈소 평균 비용(1일) : {Math.round(averagePrice).toLocaleString()}원
        </Box>
      )} */}
      <Box marginTop="6px" />
      <Stack component="ul" gap="16px">
        {parlorCardItems.map((res) => CardViewType(res))}
      </Stack>
    </Stack>
  );
}
